/* sz-filter-bar-v4.js — Clean URL active-state + AJAX product grid swap */
(function () {
  'use strict';

  var GRID_SELECTOR = '.sz-pg-v4';
  var fetchAbort = null;

  function getActiveTagFromPath(pathname) {
    var parts = (pathname || window.location.pathname).split('/').filter(Boolean);
    if (parts.length >= 3 && parts[0] === 'collections') return parts[2];
    return '';
  }

  function syncPills(activeTag) {
    document.querySelectorAll('.ap-pill').forEach(function (pill) {
      var clearAll = pill.getAttribute('data-filter-clear-all') === 'true';
      var value = pill.getAttribute('data-filter-value');
      if (clearAll) pill.classList.toggle('ap-pill--active', activeTag === '');
      else if (value) pill.classList.toggle('ap-pill--active', value === activeTag);
    });
  }

  function findGrid(root) {
    return (root || document).querySelector(GRID_SELECTOR);
  }

  function setLoading(loading) {
    var grid = findGrid();
    if (!grid) return;
    grid.classList.toggle('is-loading', loading);
    grid.setAttribute('aria-busy', loading ? 'true' : 'false');
  }

  function swapGrid(html) {
    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var newGrid = findGrid(doc);
    var oldGrid = findGrid();
    if (!newGrid || !oldGrid) return false;
    oldGrid.innerHTML = newGrid.innerHTML;
    return true;
  }

  function navigate(url, pushState) {
    if (fetchAbort) fetchAbort.abort();
    fetchAbort = new AbortController();
    setLoading(true);
    return fetch(url, { signal: fetchAbort.signal, credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.text();
      })
      .then(function (html) {
        var swapped = swapGrid(html);
        if (!swapped) {
          window.location.href = url;
          return;
        }
        if (pushState) history.pushState({ url: url }, '', url);
        syncPills(getActiveTagFromPath(new URL(url, window.location.origin).pathname));
        var grid = findGrid();
        if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      })
      .catch(function (err) {
        if (err.name === 'AbortError') return;
        window.location.href = url;
      })
      .finally(function () {
        setLoading(false);
        fetchAbort = null;
      });
  }

  function onPillClick(e) {
    var pill = e.target.closest('.ap-pill');
    if (!pill) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    navigate(pill.getAttribute('href'), true);
  }

  function onPopState() {
    navigate(window.location.href, false);
  }

  function init() {
    syncPills(getActiveTagFromPath());
    document.addEventListener('click', onPillClick);
    window.addEventListener('popstate', onPopState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
